/**
 * Test IDs for QA automation.
 */
export const testIds = {
  storageFacilityFormIdentifier: "storage-facility-form-identifier",
  storageFacilityFormManifoldOf: "storage-facility-form-manifold-of",
  storageFacilityFormManifoldOfOption: "storage-facility-form-manifold-of-option",
  storageFacilityFormPrimaryCommodityPicker: "storage-facility-form-primary-commodity-picker",
  storageFacilityFormPrimaryCommoditySearch: "storage-facility-form-primary-commodity-search",
  storageFacilityFormAdditionalCommoditiesPicker: "storage-facility-form-additional-commodities-picker",
  storageFacilityFormAdditionalCommoditiesSearch: "storage-facility-form-additional-commodities-search",
} as const;
